import { render, staticRenderFns } from "./select-sales-channel.vue?vue&type=template&id=605200c8"
import script from "./select-sales-channel.vue?vue&type=script&lang=js"
export * from "./select-sales-channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports